<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
	  <z-page title="Tangki Nitrogen">
		  <z-table title="Senarai" :headers="table.headers" :items="table.items" :meta="table.meta">
          <template #button v-if="$zutil.role('2') || $zutil.role('1') || $zutil.role('5')">
              <w-button dark class="green--bg ml1" :route="$route('tangki.form',0)" >
                  <w-icon class="mr1">fal fa-plus</w-icon> Tambah
              </w-button>
          </template>
		    <template #header-label="{ header, label, index }">
		      <template v-if="header.key == 'action'">
			      <!-- <w-icon xs>fal fa-pencil</w-icon> -->
            TINDAKAN
          </template>
		      <template v-else>
		      	{{ label }}
		      </template>
		    </template>
		    <template #item-cell.action="{ item, label, header, index }">
		      <w-flex class="flex justify-center">
		        <inertia-link :href="$route('ternakan.show',item.id)" class="w-button w-button--dark size--md info-dark1--bg"> 
              <w-icon xs class="mr2">fal fa-eye</w-icon>  Papar
            </inertia-link>
             &nbsp;  

            <w-button  bg-color="warning"  :route="$route('ternakan.form',item.id)" class="be fs-2">
              <w-icon xs class="mr2">fal fa-pencil</w-icon> Kemaskini 
            </w-button>
		      </w-flex>
		    </template>
		  </z-table>
	  </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'tengki',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Tangki Nitrogen', route: '/premis' },
      ]
      
    }
  },
  methods: {
    
  
  },

  watch: {

  },
  mounted() {
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>
